"use strict";

import Swiper from "swiper";
import { Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";

export class CardCarousel {
    constructor(el) {
        this.swiperEl = el.querySelector('.swiper');
        this.pagination = el.querySelector('.swiper-pagination');
        if (!this.swiperEl.classList.contains('swiper-initialized')) {
            this.init();
        }
    }

    init() {
        new Swiper(this.swiperEl, {
            modules: [Pagination],
            slidesPerView: 'auto',
            speed: 450,
            loop: false,
            spaceBetween: 10,
            centeredSlides: true,
            pagination: {
                el: this.pagination
            },
            on: {
                afterInit: function () {
                    let minHeight = 0;
                    this.slides.forEach(slide => {
                        if (slide.clientHeight > minHeight) {
                            minHeight = slide.clientHeight;
                        }
                    });
                    this.slidesEl.style.height = minHeight + 'px';
                },
            }
        });
    }
}
